import { DimensionDefinitionLoose, OptionSourceData } from "echarts/types/src/util/types.js";
import { ECOption } from "PFCore/helpers/echarts_wrapper";
import { Experience } from "PFTypes";

export const experienceToChartValue = (experience?: Experience): number => (experience ? experience + 1 : 0);

export const chartValueToExperience = (value: number): Experience => value - 1;

export const createFeedbackChartConfig = (
  datasetSource: OptionSourceData,
  dimensions: DimensionDefinitionLoose[],
  experienceLevels: Experience[],
  experienceLabelMap: Record<Experience, string>
): ECOption => ({
  legend: {},
  tooltip: {},
  dataset: {
    source: datasetSource,
    dimensions: ["skill", ...dimensions]
  },
  xAxis: {
    type: "category",
    axisLabel: {
      interval: 0,
      rotate: 45
    }
  },
  yAxis: {
    max: experienceToChartValue(Math.max(...experienceLevels)),
    min: 0,
    interval: 1,
    axisLabel: {
      formatter: (value: number) => {
        const experience = chartValueToExperience(value);
        return experienceLevels.includes(experience) ? experienceLabelMap[experience] : "";
      }
    }
  },
  grid: { left: "100px", bottom: "150px" },
  series: dimensions.map(() => ({
    barMaxWidth: 20,
    type: "bar"
  }))
});
